import { Tooltip } from "react-tooltip";
import { FaCircleInfo } from "react-icons/fa6"
import { useEffect, useState } from "react";
import { Checkbox, DatePicker, message } from "antd";
import { CalendarOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import ActionButtonGradient from "../../../../components/button/ActionButtonGradient";

const Initiative = ({isAPlus, payload, index, deleteInitiative, handleOnChange, watch, handleFileChange, year}) => {
    const [data, setData] = useState({})
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    
    const currentYear = new Date().getFullYear() - 1;
    
    // Function to count only characters (excluding spaces)
    const countLetters = (text) => {
        if (!text) return 0;
        return text.replace(/\s/g, '').length;
    };
    
    // Validation function for date picker
    const disabledDate = (current) => {
        if (!current) return false;
        const selectedYear = current.year();
        return selectedYear !== currentYear;
    };

    // Handle date changes with validation
    const handleDateChange = (date, dateString, fieldName) => {
        if (date && date.year() !== currentYear) {
            message.error(`Please select a date from the current year (${currentYear})`);
            return;
        }
        
        // Update local state immediately
        if (fieldName === 'StartDate') {
            setStartDate(date);
            // Clear end date if it's before the new start date
            if (endDate && date && endDate.isBefore(date)) {
                setEndDate(null);
                handleOnChange({
                    target: {
                        name: 'EndDate',
                        value: ''
                    }
                }, index);
            }
        } else if (fieldName === 'EndDate') {
            setEndDate(date);
        }
        
        // Update the parent component
        const syntheticEvent = {
            target: {
                name: fieldName,
                value: dateString || ''
            }
        };
        
        handleOnChange(syntheticEvent, index);
    };

    useEffect(() => {
        if (payload && payload[index]) {
            setData(payload[index]);
            // Set initial date values - handle different date formats
            const startDateValue = payload[index].StartDate;
            const endDateValue = payload[index].EndDate;
            
            if (startDateValue) {
                try {
                    setStartDate(dayjs(startDateValue));
                } catch (error) {
                    setStartDate(null);
                }
            } else {
                setStartDate(null);
            }
            
            if (endDateValue) {
                try {
                    setEndDate(dayjs(endDateValue));
                } catch (error) {
                    setEndDate(null);
                }
            } else {
                setEndDate(null);
            }
        } else {
            // Initialize empty data if payload is not ready
            setData({});
            setStartDate(null);
            setEndDate(null);
        }
    }, [payload, index])

    // Safety check for data
    if (!data) {
        return <div>Loading...</div>;
    }

    return(
        <>
            <style>
                {`
                .custom-date-picker-dropdown {
                    z-index: 9999 !important;
                }
                .custom-date-picker-dropdown .ant-picker-panel {
                    box-shadow: 0 3px 6px -4px rgba(0,0,0,0.12), 0 6px 16px 0 rgba(0,0,0,0.08), 0 9px 28px 8px rgba(0,0,0,0.05);
                }
                .modern-form-group {
                    margin-bottom: 1.5rem;
                }
                .modern-label {
                    display: block;
                    font-weight: 500;
                    font-size: 14px;
                    color: #333;
                    margin-bottom: 8px;
                    text-align: left;
                }
                .required-star {
                    color: #dc3545;
                    margin-left: 4px;
                }
                .modern-textarea {
                    width: 100%;
                    padding: 12px;
                    border: 1px solid #d9d9d9;
                    border-radius: 8px;
                    font-size: 14px;
                    font-family: inherit;
                    resize: vertical;
                    transition: border-color 0.3s ease, box-shadow 0.3s ease;
                }
                .modern-textarea:focus {
                    outline: none;
                    border-color: #02B4CC;
                    box-shadow: 0 0 0 2px rgba(2, 180, 204, 0.1);
                }
                .modern-textarea:disabled {
                    background-color: #f5f5f5;
                    cursor: not-allowed;
                }
                .char-counter {
                    font-size: 12px;
                    color: #666;
                    margin-top: 4px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }
                .char-counter.error {
                    color: #dc3545;
                }
                .char-counter.success {
                    color: #28a745;
                }
                .helper-text {
                    font-size: 12px;
                    color: #666;
                    margin-top: 4px;
                    display: flex;
                    align-items: center;
                    gap: 4px;
                }
                .info-icon-inline {
                    color: #02B4CC;
                    cursor: help;
                }
                .modern-file-input {
                    width: 100%;
                    padding: 10px 12px;
                    border: 1px solid #d9d9d9;
                    border-radius: 8px;
                    font-size: 14px;
                    cursor: pointer;
                }
                .modern-file-input::file-selector-button {
                    padding: 6px 16px;
                    margin-right: 12px;
                    background-color: #f0f0f0;
                    border: 1px solid #d9d9d9;
                    border-radius: 6px;
                    cursor: pointer;
                    font-size: 14px;
                    transition: all 0.2s ease;
                }
                .modern-file-input::file-selector-button:hover {
                    background-color: #e0e0e0;
                }
                .modern-file-input:disabled::file-selector-button {
                    background-color: #f5f5f5;
                    cursor: not-allowed;
                }
                `}
            </style>
            <div>
            <div style={{ padding: '8px 0' }}>
                <form onSubmit={(e) => e.preventDefault()}>
                    {
                        isAPlus &&
                        <div className="modern-form-group">
                            <Checkbox
                                name="IsProject"
                                onChange={(e) => handleOnChange(e,index)}
                                checked={data.IsProject || false}
                                disabled={watch}
                            />
                            <label className="ms-2 me-4">New Innovation Project</label>
                            <Checkbox
                                name="IsInitiative"
                                onChange={(e) => handleOnChange(e,index)}
                                checked={data.IsInitiative || false}
                                disabled={watch}
                            />
                            <label className="ms-2 me-4">Beyond Job Scope</label>
                        </div>
                    }
                    
                    {/* Initiative Name */}
                    <div className="modern-form-group">
                        <label className="modern-label">
                            Initiative Name
                            <span className="required-star">*</span>
                            <FaCircleInfo
                                fontSize={14}
                                className="ms-2 info-icon-inline"
                                data-tooltip-id="tooltip-initiative"
                            />
                        </label>
                        <textarea
                            disabled={watch}
                            minLength={10}
                            maxLength={100}
                            required
                            rows={2}
                            name="Initiative"
                            className="modern-textarea"
                            placeholder="Enter initiative name (minimum 10 characters)"
                            onChange={(e) => handleOnChange(e,index)}
                            value={data.Initiative || ''}
                        />
                        <div className={`char-counter ${countLetters(data.Initiative) < 10 ? 'error' : 'success'}`}>
                            <span>{countLetters(data.Initiative) < 10 ? `${10 - countLetters(data.Initiative)} more characters needed` : 'Minimum requirement met ✓'}</span>
                            <span>{data.Initiative?.length || 0} / 100</span>
                        </div>
                    </div>
                    
                    {/* Description */}
                    <div className="modern-form-group">
                        <label className="modern-label">
                            Description
                            <span className="required-star">*</span>
                            <FaCircleInfo
                                fontSize={14}
                                className="ms-2 info-icon-inline"
                                data-tooltip-id="tooltip-description"
                            />
                        </label>
                        <textarea
                            disabled={watch}
                            minLength={20}
                            maxLength={700}
                            required
                            rows={4}
                            name="Description"
                            className="modern-textarea"
                            placeholder="Explain the initiatives, contributions/roles in detail (minimum 20 characters)"
                            onChange={(e) => handleOnChange(e,index)}
                            value={data.Description || ''}
                        />
                        <div className={`char-counter ${countLetters(data.Description) < 20 ? 'error' : 'success'}`}>
                            <span>{countLetters(data.Description) < 20 ? `${20 - countLetters(data.Description)} more characters needed` : 'Minimum requirement met ✓'}</span>
                            <span>{data.Description?.length || 0} / 700</span>
                        </div>
                    </div>
                    
                    {/* Tangible Impact */}
                    <div className="modern-form-group">
                        <label className="modern-label">
                            Tangible Impact
                            <span className="required-star">*</span>
                            <FaCircleInfo
                                fontSize={14}
                                className="ms-2 info-icon-inline"
                                data-tooltip-id="tooltip-impact"
                            />
                        </label>
                        <textarea
                            disabled={watch}
                            minLength={10}
                            maxLength={700}
                            required
                            rows={4}
                            name="Result"
                            className="modern-textarea"
                            placeholder="Explain the measurable impact (cost, process improvement, time savings, etc.)"
                            onChange={(e) => handleOnChange(e,index)}
                            value={data.Result || ''}
                        />
                        <div className={`char-counter ${countLetters(data.Result) < 10 ? 'error' : 'success'}`}>
                            <span>{countLetters(data.Result) < 10 ? `${10 - countLetters(data.Result)} more characters needed` : 'Minimum requirement met ✓'}</span>
                            <span>{data.Result?.length || 0} / 700</span>
                        </div>
                    </div>
                    
                    {/* Date Range */}
                    <div className="modern-form-group">
                        <div style={{display: 'flex', gap: '16px'}}>
                            <div style={{flex: 1}}>
                                <label className="modern-label">
                                    Start Date
                                    <span className="required-star">*</span>
                                </label>
                                <DatePicker
                                    disabled={watch}
                                    picker="month"
                                    placeholder="Select start month"
                                    style={{width: '100%', height: '44px', borderRadius: '8px'}}
                                    value={startDate}
                                    disabledDate={disabledDate}
                                    onChange={(date, dateString) => handleDateChange(date, dateString, 'StartDate')}
                                    format="YYYY-MM"
                                    allowClear={true}
                                    showToday={false}
                                    defaultPickerValue={dayjs(`${currentYear}`)}
                                    suffixIcon={<CalendarOutlined style={{cursor: 'pointer', fontSize: '16px', color: '#02B4CC'}} />}
                                    getPopupContainer={(trigger) => trigger.parentElement}
                                    dropdownClassName="custom-date-picker-dropdown"
                                />
                            </div>
                            <div style={{flex: 1}}>
                                <label className="modern-label">
                                    End Date
                                    <span className="required-star">*</span>
                                </label>
                                <DatePicker
                                    disabled={watch}
                                    picker="month"
                                    placeholder="Select end month"
                                    style={{width: '100%', height: '44px', borderRadius: '8px'}}
                                    value={endDate}
                                    disabledDate={(current) => {
                                        if (!current) return false;
                                        const selectedYear = current.year();
                                        if (selectedYear !== currentYear) return true;
                                        if (startDate && current.isBefore(startDate)) return true;
                                        return false;
                                    }}
                                    onChange={(date, dateString) => handleDateChange(date, dateString, 'EndDate')}
                                    format="YYYY-MM"
                                    allowClear={true}
                                    showToday={false}
                                    defaultPickerValue={dayjs(`${currentYear}`)}
                                    suffixIcon={<CalendarOutlined style={{cursor: 'pointer', fontSize: '16px', color: '#02B4CC'}} />}
                                    getPopupContainer={(trigger) => trigger.parentElement}
                                    dropdownClassName="custom-date-picker-dropdown"
                                />
                            </div>
                        </div>
                        <div className="helper-text">
                            <FaCircleInfo fontSize={12} style={{color: '#02B4CC'}} />
                            Only dates from the current year ({currentYear}) are allowed
                        </div>
                    </div>
                    
                    {/* General Comment */}
                    <div className="modern-form-group">
                        <label className="modern-label">
                            General Comment
                        </label>
                        <textarea
                            disabled={watch}
                            maxLength={150}
                            rows={3}
                            name="Comment"
                            className="modern-textarea"
                            placeholder="Optional: Add your general comments"
                            onChange={(e) => handleOnChange(e,index)}
                            value={data.Comment || ''}
                        />
                        <div className="char-counter">
                            <span>Optional field</span>
                            <span>{data.Comment?.length || 0} / 150</span>
                        </div>
                    </div>
                </form>

                {/* Evidence File Upload */}
                {
                    data.EvidenceLink && data.EvidenceLink !== "" &&
                    <div className="modern-form-group">
                        <label className="modern-label">Current Evidence File</label>
                        <div style={{
                            padding: '12px',
                            backgroundColor: '#f8f9fa',
                            borderRadius: '8px',
                            border: '1px solid #e9ecef'
                        }}>
                            <button
                                type="button"
                                style={{
                                    fontSize: '14px', 
                                    color: '#02B4CC',
                                    textDecoration: 'none',
                                    fontWeight: 500,
                                    background: 'none',
                                    border: 'none',
                                    padding: 0,
                                    cursor: 'pointer'
                                }} 
                                onClick={() => {
                                    window.open(data.EvidenceLink, "_blank", "noreferrer")
                                }}
                            >
                                📎 {data.EvidenceName}
                            </button>
                            <div style={{fontSize: '12px', color: '#666', marginTop: '4px'}}>
                                <i>Upload a new file to replace this</i>
                            </div>
                        </div>
                    </div>
                }

                <div className="modern-form-group">
                    <label className="modern-label">
                        Evidence File Upload
                    </label>
                    <input 
                        className="modern-file-input"
                        name="Evidence"
                        type="file" 
                        accept="application/pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.ppt,.pptx,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,.zip,application/zip,image/*"
                        onChange={(e) => handleFileChange(e, index)}
                        disabled={watch}
                    />
                    <div className="helper-text">
                        <FaCircleInfo fontSize={12} style={{color: '#02B4CC'}} />
                        Max 5 MB • PDF, Word, Excel, PowerPoint, ZIP, Images
                    </div>
                </div>

                {
                    index > 0 &&
                    <div style={{marginTop: '24px', paddingTop: '16px', borderTop: '1px solid #e9ecef'}}>
                        <ActionButtonGradient
                            variant="danger"
                            onClick={() => deleteInitiative(index, data.ID, payload)}
                            children={"Delete Initiative"}
                        />
                    </div>
                }
            </div>
            <Tooltip
                id="tooltip-initiative"
                style={{ 
                    backgroundColor: "#efefef", 
                    color: "#222", 
                    width: "20rem",
                    textAlign: "left",
                    alignItems: "center"
                }}
            >
                <span>Initiative Name. Minimum length: 10 characters</span>
            </Tooltip>
            <Tooltip
                id="tooltip-description"
                style={{ 
                    backgroundColor: "#efefef", 
                    color: "#222", 
                    width: "20rem",
                    textAlign: "left"
                }}
            >
                <span>Explain in detail the initiatives, contributions/roles of employees related to the business. Minimum length: 20 characters</span>
            </Tooltip>
            <Tooltip
                id="tooltip-impact"
                style={{ 
                    backgroundColor: "#efefef", 
                    color: "#222", 
                    width: "20rem",
                    textAlign: "left"
                }}
            >
                <span>Explain the cost impact, process improvement, time savings, or the impact of recognition/acknowledgment resulting from the initiative. Minimum length: 10 characters</span>
            </Tooltip>
            <Tooltip
                id="tooltip-comment"
                style={{ 
                    backgroundColor: "#efefef", 
                    color: "#222", 
                    width: "20rem",
                    textAlign: "left"
                }}
            >
                <p>Your comment regarding the employees</p>
            </Tooltip>
        </div>
        </>
    )
}

export default Initiative